import SearchBox from "../../../lib/search-box/search-box";

window.SearchBoxResp = function (options) {
	const _self = this,
		_settings = {
			...{}, ...options
		};
	const $seachBoxContainer = $('#searchBox'),
		$searchBoxMoreBtn = $('#searchBox .search-form__toggle'),
		$searchBoxform = $('#searchBox form.__js-sb-form'),
		$overlay = $('.js-backdrop'),
		heroHeightSticked = getHeroHeight(false),
		nbMaxSelectChar = 50,
		customSelect = $(".ho-custom-select"),
		$formGroupCustom = $.makeArray($('.form-group-custom')),
		$formGroupCustomMain = $.makeArray($('.form-group-custom.form-group-custom--main')),
		$submitBtn = $('#searchBox .__js-sb-submit');

	function _init() {
		new SearchBox($('#searchBox'));
		_initSearchBoxButton();
		_initSearchBoxForm();
		_initCustomSelect();
		_initSearchBoxAutocomplete();
		_initSearchBoxBtn();
		_initGeneralSearchBox();
		_initSearchBoxFlow();
	}

	function _initSearchBoxFlow() {
		$searchBoxform.find('input').on('keypress', function (e) {
			var keyCode = e.keyCode || e.which;
			if (keyCode === 13) {
				processNextElement($(this))
				e.preventDefault();
				return false;
			}
		});
		$(document).keydown(function (e) {

			if ($('.form-group-custom.active input[type=text],.form-group-custom.active input[type=number]').length > 0) {

				return null;
			}


			let $currentDropdown = $('.dropdown.active');

			if ($currentDropdown.length != 0 ) {

				let currentItem = $currentDropdown.find('.card .item.active ,.search-box__moment-radio-group .btn.active, .booking-custom-toggle input.active');
				console.log(currentItem)
				switch (e.which) {
					case 40:
					case 37:
						if ($currentDropdown.find('.item:not(.title).active').length == 0) {
							$currentDropdown.find('.item:not(.title)').first().addClass('active');
						}
						if (currentItem.next(['.item', 'btn','input']).length > 0) {
							currentItem.next(['.item', 'btn','input']).addClass('active');
							currentItem.removeClass('active');
						}
						e.preventDefault()
						break;
					case 38:
					case 39:
						if ($currentDropdown.find('.item:not(.title).active').length == 0) {
							$currentDropdown.find('.item:not(.title)').first().addClass('active');
						}
						if (currentItem.prev(['.item', 'btn', 'input']).length > 0) {
							currentItem.prev(['.item', 'btn', 'input']).addClass('active');
							currentItem.removeClass('active');
						}
						e.preventDefault()
						break;

					case 13:
						currentItem.trigger('click');
						processNextElement(currentItem)
						e.preventDefault()
						break;
					default :
						break;
				}
			}
		});
	}

	function _initSearchBoxButton() {
		let $triggerBackdrop = document.querySelector('.js-backdrop');
		let $backdropEl = $('.js-backdrop');


		$searchBoxMoreBtn.on('click', function (e) {

			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();

			if ($seachBoxContainer.hasClass('js-search-box--fixed')) {
				if ($(window).scrollTop() < heroHeightSticked) {
					$([document.documentElement, document.body]).animate({
						scrollTop: heroHeightSticked + 200
					}, 300);
				}
			}

			$seachBoxContainer.toggleClass('active');

			if (!$seachBoxContainer.hasClass('active')) {
				window.layoutBackdrop.hide()
			} else {
				window.layoutBackdrop.show()
			}
		});

		$overlay.on('click', function () {
			if ($seachBoxContainer.hasClass('active')) {
				// $searchBoxform.slideUp();
				$seachBoxContainer.removeClass('active')
			}
		});
	}

	function _initSearchBoxAutocomplete() {
		let input = $('#input_location'),
			lat = $('.__js-sb-lat'),
			lng = $('.__js-sb-lng');

		input.on("focusout", function (e) {

			if ($(this).val() == '') {
				lat.val('');
				lng.val('');
			} else {
				//processNextElement($(this))
			}
		})
	}


	function _initSearchBoxBtn() {
		$('.search-box__moment-radio-group .btn:not(.custom-date)').on('click', function () {
			// $(this).find('.__js-sb-moment-radio').prop("checked", true);
			$(this).parents('.dropdown').removeClass('active').slideUp();
			$('.form-group-custom.active').removeClass('active');
			$('.__js-sb-moment-btn').html($(this).text());
			$('.__js-sb-submit').focus();
		})

		$('#searchBox .__js-sb-moment-btn').text($('.search-box__moment-radio-group .btn.active > span').text())
		if ($('.custom-date').hasClass('active') && $('#input_moment_date').val() != '') {
			$('.search-box__datepicker').closest('.search-box__input-group').find('.__js-sb-moment-btn').text(new Date($('#input_moment_date').val()).toLocaleDateString("fr"))
		}

	}

	function _initSearchBoxForm() {
		let $inputGroups = $('#searchBox form .form-group-custom'),
			$dropdowns = $('#searchBox form  .dropdown');


		$inputGroups.each(function () {
			const $this = $(this);
			$this.on('click', function (e) {
				if (!$(e.target).hasClass('d-none') && $seachBoxContainer.hasClass('search-box--jumbotron')) {
					$('.search-bar').animate({
						scrollTop: ($(e.target).closest('.form-group-custom').position().top + $(e.target).position().top - 212)
					}, 500);
				}

				if (!$(this).hasClass('active') && !$(e.target).closest('label').hasClass('custom-date') ) {
					closeAllFormInput();
				}

				let inputGroup = $(this).closest('.form-group-custom'),
					activeInputGroup = $('.form-group-custom.active'),
					finded = false;
				activeInputGroup.each(function () {
					if (!$(this).is(inputGroup)) {
						$(this).removeClass('active');
					} else {
						finded = true;
					}
				})
				if (inputGroup.length > 0 && !$(e.target).parents('.dropdown').length > 0 && !finded) {
					$('#searchBox').removeClass('after-modal');
					if (!$seachBoxContainer.hasClass('focus')) {
						$seachBoxContainer.addClass('focus');
					}
					inputGroup.addClass('active');
				}

				if ($(e.target).parents('.modal:not(#searchConstatModal) ').length){
					processNextElement($(e.target))
				}
			});
		})
		$dropdowns.each(function () {
			const $this = $(this);
			$this.slideUp();

			$this.closest('.form-group-custom').on('click', function (e) {

				if (window.matchMedia("(min-width: 992px)").matches && $('.hero-banner.listing').length === 0 && $seachBoxContainer.hasClass('search-box--jumbotron')) {
					let $height = (($(window).height() - 68 - 460) / 2) + 134;
					if ($(window).scrollTop() < $height) {
						$([document.documentElement, document.body]).animate({
							scrollTop: $height
						}, 500, function () {
						});
					}
				}else{
					if (window.matchMedia("(max-width: 992px)").matches) {
						let $height = $(e.target).offset().top - $('#searchBox form .form-container').offset().top;
						if ($('#searchBox form .form-container').scrollTop() < $height) {
							$('#searchBox form .form-container').animate({
								scrollTop: $height
							}, 500, function () {
							});
						}
					}
				}

				let item = $(e.target).parent();
				if (item.hasClass('btn')) {
					if (item.hasClass('btn') && !item.hasClass('custom-date')) {
						item.closest('.search-box__input-group').find('.__js-sb-moment-btn').text(item.text());
					}
				} else {
					toggleDropdown($(e.target), $this);

					if ($(e.target).parents('.dropdown').length == 0) {
						$('#searchBox .__js-sb-submit').focus();
					}
					if ($this.find(' .__js-sb-moment-datepicker').length > 0 && $this.find('.custom-date.active').length > 0) {
						setTimeout(function () {
							$this.addClass('calendar-displayed');
							$this.find(' .__js-sb-moment-datepicker').addClass('show')
						},500)
					}
				}

			});
		})

		$('.search-box__datepicker').on('changeDate', function (e) {
			toggleDropdown($(e.target), $(this).parents('.dropdown'), true);
			$(this).closest('.search-box__input-group').find('.__js-sb-moment-btn').text(new Date($('#input_moment_date').val()).toLocaleDateString("fr"));
			$('#searchBox .__js-sb-submit').focus();
			$(this).parents('.form-group-custom').removeClass('active');
			e.stopPropagation();
		});

	}

	function toggleDropdown($el, $dropdownEl, forced = false) {
		if ($el.parents('.dropdown').length == 0 || forced) {

			$dropdownEl.toggleClass('active');
			if (!$seachBoxContainer.hasClass('focus')) {
				$seachBoxContainer.addClass('focus');
			}
			if ($dropdownEl.hasClass('active')) {
				$dropdownEl.slideDown();
			} else {
				$dropdownEl.slideUp();
			}
		}
	}

	function closeAllFormInput() {
		let $dropdowns = $('#searchBox form .form-group-custom .dropdown');

		$dropdowns.each(function () {
			$(this).slideUp();
			$(this).removeClass('active');
			$(this).closest('.form-group-custom').removeClass('active');
		})
		$('.form-group-custom').removeClass('active');
	}

	function getHeroHeight(max = true) {
		let heroHeight = 0;

		$('.hero-element').each(function () {
			if (max || $(this).hasClass('home-jumbotron')) {
				heroHeight += $(this).outerHeight();
			}
		});

		if (max === false) {
			heroHeight -= $('.main-header.js-fixed-header-on-scroll').outerHeight();
		}

		return heroHeight;
	}

	function _initCustomSelect() {

		customSelect.each(function () {
			var thisCustomSelect = $(this),
				customSelectContent = thisCustomSelect.next('.dropdown'),
				options = thisCustomSelect.find("option"),
				firstOptionText = options.first().text(),
				selectValue = formatOptionTitle(firstOptionText, '(', ')', true),
				firstOptionValue = true;

			var selectedItem = $("<div></div>", {
				class: "selected-item"
			})
				.appendTo(thisCustomSelect)
				.text(selectValue.substring(0, nbMaxSelectChar) + (selectValue.length > nbMaxSelectChar ? '...' : ''));

			var allItems = $("<div></div>", {
				class: "card card-body"
			}).appendTo(customSelectContent);


			options.each(function () {
				const customTitle = "Sélectionner votre type de constat"
				var that = $(this),
					optionText = (that.text() == "Type de constat") ? customTitle : that.text(),
					itemClass = "";


				optionText = formatOptionTitle(optionText, '(', ')')
				if (firstOptionValue) {
					itemClass = "item title";
				} else {
					itemClass = "item";
				}
				var item = $("<div></div>", {
					class: itemClass,
					on: {
						click: function () {
							if (!$(this).hasClass('title')) {
								var selectedOptionText = that.text(),
									selectValue = formatOptionTitle(selectedOptionText, '(', ')', true).trim();
								selectedItem.text(selectValue.substring(0, nbMaxSelectChar) + (selectValue.length > nbMaxSelectChar ? '...' : '')).removeClass("active");
								allItems.remove("active");
								$('.card .item.active').removeClass('active');
								$(this).addClass("active");
								thisCustomSelect.find('option:selected').removeAttr("selected");
								thisCustomSelect.find('option[value="' + that.val() + '"]').attr("selected", "selected");
								thisCustomSelect.find('select').trigger('change');
								processNextElement($(this), that)
							}

						},
					},
					value: that.val()
				})
					.appendTo(allItems)
					.html(optionText);

				firstOptionValue = false


			});

			var selectedItem = thisCustomSelect.find(".selected-item"),
				allItems = thisCustomSelect.find(".all-items");

			selectedItem.on("click", function (e) {
				var currentSelectedItem = $(this),
					currentAllItems = currentSelectedItem.parent().next(".dropdown");
				allItems.not(currentAllItems).removeClass("active");
				selectedItem.not(currentSelectedItem).removeClass("active");
				currentSelectedItem.closest(".form-group-custom").toggleClass("active");
				currentAllItems.toggleClass("active");
				if (currentAllItems.hasClass("active")) {
					currentAllItems.slideDown();

				} else {
					currentAllItems.slideUp();
				}
				e.stopPropagation();
			});


			let selectedOption = null;
			thisCustomSelect.find('option').each(function () {
				if ($(this).attr('selected') == 'selected'){
					selectedOption = $(this)
				}
			})

			if (selectedOption.length > 0) {

				let selectValue = selectedOption.text(),
					linkedItem = thisCustomSelect.parents('.form-group-custom').find('.item[value="' + selectedOption.val() + '"]'),
					linkedOptionalDisplay = $('.js-optional-display[data-is-value="' + selectedOption.val() + '"]');
				selectedItem.html(formatOptionTitle(selectValue, '(', ')', true));
				$('.card .item.active').removeClass('active');
				linkedItem.toggleClass("active");

				if (linkedOptionalDisplay.length != 0) {
					linkedOptionalDisplay.parents('.js-optional-display-container').addClass('preselected');
				}
			}
		});
	}

	function _initGeneralSearchBox() {

		$(document).on("click", function (e) {
			var opened = $(".all-items:not(.all-items-hide)"),
				index = opened.parent().index();

			customSelect
				.eq(index)
				.parent()
				.find(".ho-custom-select-content .all-items")
				.addClass("all-items-hide");
			customSelect
				.eq(index)
				.find(".selected-item")
				.removeClass("arrowanim");


			if ($(e.target).parents('.search-bar').length == 0) {
				closeAllFormInput();
				$(this).closest('.form-group-custom').removeClass('active');
				$seachBoxContainer.removeClass('focus');
			}


			if($(e.target).parents('.dropdown').length == 0 && $('.calendar-displayed .__js-sb-moment-datepicker').length > 0){
				$('.calendar-displayed .__js-sb-moment-datepicker').removeClass('show').parents('.dropdown').removeClass('calendar-displayed');
			}

		})

		$('#searchBox .__js-sb-moment-btn').on('click', function (e) {
			e.preventDefault()
		});

		$searchBoxform.on('change', function (e) {
			let submitable = true;

			$(this).find('input').each(function () {
				if ($(this).val() == '' && $(this).is(':visible') && $(this).attr('type') != 'hidden') {
					submitable = false;
				}
			})

			if (submitable) {
				$submitBtn.addClass('submitable')
			} else {
				$submitBtn.removeClass('submitable')
			}
		})

	}

	function formatOptionTitle(string, char1, char2, extractSubstring = false) {
		let substring = string.slice(
				string.indexOf(char1),
				string.lastIndexOf(char2) + 1,
			),
			result = "";

		if (extractSubstring) {
			result = string.replace(substring, '');
		} else {
			result = '<strong>' + string.replace(substring, '') + "</strong>" + substring;
		}

		return result;
	}

	function _updateMomentBtnText() {
		const $dateRadio = _components.$momentRadio.filter((i, el) => $(el).attr('name') === 'moment_radio_date' && $(el).is(':checked')),
			$timeRadio = _components.$momentRadio.filter((i, el) => $(el).attr('name') === 'moment_radio_time' && $(el).is(':checked'));
		let txt = '';

		if ($dateRadio.val() === 'anyway') {
			_components.$momentDate.val('');
		} else if ($dateRadio.val() === 'today') {

			const t = new Date();
			txt = _formatDateForHuman(t);
			_components.$momentDate.val(_formatDateToIso(t));
		} else if ($dateRadio.val() === 'tomorrow') {
			const t = new Date();
			txt = _formatDateForHuman(t.addDays(1));
			_components.$momentDate.val(_formatDateToIso(t.addDays(1)));
		} else if ($dateRadio.val() === 'custom') {
			let t = _components.$momentDatepicker.datepicker('getDate') || new Date();
			if (getUrlParameter('moment_date') && _components.$momentDatepicker.datepicker('getDate') == null) {
				t = new Date(getUrlParameter('moment_date'))
			}

			_components.$momentDate.val();
			txt = _formatDateForHuman(t);
		}

		if ($timeRadio.val() === 'custom') {
			let time = '';

			_components.$momentTime.each(function (i, input) {
				if ($(input).hasClass('from-input')) {
					time = $(input).val() + time;
				} else if ($(input).hasClass('to-input')) {
					time = time + ' - ' + $(input).val();
				}
			});
			txt = txt + ' ' + time;
		}
		_components.$momentBtn.val(txt);
	}

	function processNextElement(el, parent = $('#input_constat_type')) {
		el.parents('.form-group-custom').removeClass('active');
		$('.dropdown').each(function () {
			$(this).hide()
		})
		let nextEl = $submitBtn;
		let item = $.makeArray(el.parents('.form-group-custom'))[0],
			optional = $('.js-optional-display[data-is-value="' + parent.val() + '"]');

		if (optional.length == 0 && parent.parents('.js-optional-display').length == 0) {
			nextEl = $($formGroupCustomMain[$.inArray(item, $formGroupCustomMain) + 1])
		} else {
			nextEl = $($formGroupCustom[$.inArray(item, $formGroupCustom) + 1])
		}

		if (nextEl.find('.dropdown').length > 0) {
			nextEl = nextEl.find('.dropdown')
		} else if (nextEl.find('input.form-control').length > 0) {
			nextEl = nextEl.find('input.form-control')
		}else if(nextEl.find('input.form-check-input').length > 0){
			nextEl = nextEl.find('input.form-check-input').first()
		}


		if (window.matchMedia("(min-width: 992px)").matches || !(nextEl.is('input:text') || nextEl.is('input:number'))) {
			nextEl.parents('.form-group-custom').addClass('active').click();
			nextEl.focus()
		}


	}

	_init();

};
